'use strict';

/**
 * @ngdoc service
 * @name courseApp.BasicService
 * @description
 * # Service
 * Service in the courseApp.
 */
angular.module('courseApp')
    .service('BasicServiceBrowser', function ($http, $cookies, $document, $location) {
        return {
            http: $http,
            cookies: $cookies,
            document: $document,
            location: $location
        };
    });

angular.module('courseApp')
    .service('BasicService', function (BasicServiceBrowser, $filter, $timeout) {
        return {
            http: BasicServiceBrowser.http,
            cookies: BasicServiceBrowser.cookies,
            document: BasicServiceBrowser.document,
            location: BasicServiceBrowser.location,
            filter: $filter,
            timeout: $timeout
        };
    });
